module.exports = __webpack_public_path__ + "static/media/Menu.b9301686.svg";